import React from 'react';
import { Column } from '../../../../hooks/useTablePages';
import { WaterHazardItem } from './WaterHazards.query';
import StatusChip from '../../../../components/Status/StatusChip';

const columns: Column[] = [
  {
    header: 'ID',
    accessor: 'id',
    width: 100,
  },
  {
    header: 'Name',
    accessor: 'name',
    width: 250,
  },
  {
    id: 'hazardLevel',
    header: 'Hazard Level',
    accessor: (item: WaterHazardItem) => (
      <StatusChip status={item.hazardLevel === 'HIGH' ? 'error' : 'warning'}>
        {item.hazardLevel}
      </StatusChip>
    ),
    stringAccessor: (item: WaterHazardItem) => item.hazardLevel,
    width: 200,
  },
  {
    header: 'Description',
    accessor: 'description',
    width: 750,
  },
];

export default columns;
